import { type TranslationKey, translate } from '../i18n';
import { clear, el, icon } from '../lib/dom';
import type { AppState, TabId } from '../store/app';

/**
 * Tab bar. DS razred je .ao-tabbar / .ao-tab (T5 §6) — Nesywave se prilagodi DS-u,
 * ker ga druge aplikacije družine že pričakujejo. Elementi so <a href="#tab">,
 * kot v DS demu: gumb nazaj s tem deluje brez dodatne kode.
 */

interface TabDef {
  id: TabId;
  labelKey: TranslationKey;
  icon: string;
}

const TAB_DEFS: TabDef[] = [
  { id: 'stations', labelKey: 'tab.stations', icon: 'i-radio' },
  { id: 'search', labelKey: 'tab.search', icon: 'i-search' },
  { id: 'history', labelKey: 'tab.history', icon: 'i-list-ul' },
  { id: 'timer', labelKey: 'tab.timer', icon: 'i-clock' },
  { id: 'settings', labelKey: 'tab.settings', icon: 'i-settings' },
];

export function createTabbar(root: HTMLElement): { update(state: AppState): void } {
  const links = new Map<TabId, HTMLAnchorElement>();
  const labels = new Map<TabId, HTMLSpanElement>();

  clear(root);
  for (const def of TAB_DEFS) {
    const label = el('span');
    const link = el('a', { class: 'ao-tab', href: `#${def.id}` }, [icon(def.icon, 22), label]);
    links.set(def.id, link);
    labels.set(def.id, label);
    root.append(link);
  }

  return {
    update(state) {
      root.setAttribute('aria-label', translate(state.lang, 'a11y.mainNav'));

      for (const def of TAB_DEFS) {
        const link = links.get(def.id);
        const label = labels.get(def.id);
        if (link === undefined || label === undefined) continue;

        label.textContent = translate(state.lang, def.labelKey);

        const active = state.tab === def.id;
        link.classList.toggle('on', active);
        if (active) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      }
    },
  };
}
